import React, { useMemo } from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { assetUrl } from 'utils/url'
import { useKemudahanSurveyDialog } from 'app/KinerjaShared/hooks/use-kemudahan-survey-dialog'
import { useKemudahanSurveyTrackEvent } from 'app/KinerjaShared/hooks/use-kemudahan-survey-track-event'
import { useAuth } from 'utils/auth'
import { StatusPerencanaanList } from 'types/kinerja-penilik-pegawai'

import type { StatusPerencanaan } from 'types/kinerja-penilik-pegawai'

type PerencanaanKemudahanSurveyCardProps = {
  className?: string
  perencanaanStatus: StatusPerencanaan
}

export function PerencanaanKemudahanSurveyCard({
  className,
  perencanaanStatus,
}: PerencanaanKemudahanSurveyCardProps) {
  // -------------------------
  // Handle Kemudahan Survey
  // -------------------------
  const { session } = useAuth()
  const ptkId = session?.user?.ptkId

  const {
    isEnabled: isSurveyEnabled,
    isSubmitted: isSurveySubmitted,
    markAsSubmitted: markAsSubmittedSurvey,
  } = useKemudahanSurveyDialog({
    type: 'perencanaan-penilik',
    additionalKey: ptkId,
  })

  const { trackEvent: trackSurveyEvent } = useKemudahanSurveyTrackEvent()

  const handleClickSurvey = () => {
    trackSurveyEvent({
      actor: 'penilik',
      eventAction: 'view_gform',
      eventCategory: 'survey_kemudahan_perencanaan',
    })
    markAsSubmittedSurvey()
  }

  // -------------------------
  // Resolve visibility
  // -------------------------

  const isPerencanaanSubmitted = useMemo(() => {
    const currentStateIndex = StatusPerencanaanList.indexOf(perencanaanStatus)
    const submittedStateIndex =
      StatusPerencanaanList.indexOf('SEDANG_DIPERIKSA')

    return currentStateIndex >= submittedStateIndex
  }, [perencanaanStatus])

  const shouldShow =
    isSurveyEnabled && !isSurveySubmitted && isPerencanaanSubmitted

  if (!shouldShow) {
    return null
  }

  return (
    <section
      className={clsx(
        'p-6 bg-white rounded-lg shadow-card space-y-4',
        className
      )}
    >
      <div className="flex gap-4 items-start">
        <img
          src={assetUrl('/illustrations/img-term-condition-TnC-list.png')}
          className="w-16 h-16 flex-shrink-0"
          alt=""
        />
        <Text variant="body-sm">
          Ada saran dan masukan untuk tahap <strong>Perencanaan</strong>?
          Ceritakan ke kami melalui survei.
        </Text>
      </div>

      <Button
        as="a"
        href="https://forms.gle/Y2oPxf39zTU41huz9"
        target="_blank"
        rel="noopener noreferrer"
        size="lg"
        color="white"
        fullWidth
        onClick={handleClickSurvey}
      >
        Isi Survei Perencanaan
      </Button>
    </section>
  )
}
